import type { TFunction } from 'i18next';

/**
 * Komunikat przeznaczony do wyświetlenia użytkownikowi, trzymany w stanie komponentu.
 *
 * Przechowujemy KLUCZ i18n, a nie gotowy tekst. Wywołanie `t('...')` w handlerze
 * (onSuccess/onError/catch) rozwiązuje tłumaczenie raz — w języku aktywnym w chwili
 * akcji — i zamraża je w stanie. Po przełączeniu pl<->en i18next przerenderowuje
 * komponent, ale taki komunikat zostaje w starym języku, bo klucz już przepadł.
 *
 * Wariant `text` jest dla treści spoza katalogu tłumaczeń (komunikaty backendu),
 * których i tak nie mamy jak przetłumaczyć po stronie klienta.
 *
 * @see renderMessage — rozwinięcie do napisu, wołane przy renderze.
 */
export type Message =
  | { kind: 'key'; key: string; params?: Record<string, unknown> | undefined }
  | { kind: 'text'; text: string };

/** Komunikat z katalogu tłumaczeń; tłumaczony przy każdym renderze. */
export function msgKey(key: string, params?: Record<string, unknown>): Message {
  return { kind: 'key', key, params };
}

/** Tekst spoza katalogu (np. `error.response.data.message` z backendu). */
export function msgText(text: string): Message {
  return { kind: 'text', text };
}

/**
 * Rozwija komunikat do napisu w aktualnym języku. Wołać w ciele renderu,
 * nigdy w handlerze zdarzenia.
 */
export function renderMessage(message: Message | null | undefined, t: TFunction): string | null {
  if (!message) return null;
  if (message.kind === 'text') return message.text;
  return message.params ? t(message.key, message.params) : t(message.key);
}
